import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import { Checkbox, Radio, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import { GrappleModule } from "../../../interfaces/api/GrappleModule";
import { Rototilt } from "../../../interfaces/api/Rototilt";
import { ListObject } from "../../../shared/types/ListObject";
import Badge from "../Badge";
import ProductImage from "../ProductImage";
import { ListSelectMode } from "./ListRow";
import "./ListTable.scss";

interface ListMobileProps {
  configLink?: string;
  content: string;
  imageLink: string;
  isRecommended?: boolean;
  isSelected: boolean;
  selectMode?: ListSelectMode;
  object: GrappleModule | ListObject | Rototilt;
  onChange(object: GrappleModule | ListObject | Rototilt): void;
  preContent: string;
  readMeText?: string;
  readMeUrl?: string;
  title: string;
  titleMaxWidth?: string;
  titleTruncate?: boolean;
}

const ListMobile = ({
  content,
  configLink,
  imageLink,
  isRecommended = false,
  isSelected,
  object,
  onChange,
  preContent,
  readMeText,
  readMeUrl,
  selectMode = ListSelectMode.Single,
  title,
  titleMaxWidth,
  titleTruncate = false,
}: ListMobileProps) => {
  const fontSize = 18;
  const { t } = useTranslation("machinefixings");
  if (readMeText && readMeUrl) {
    content =
      content +
      "<a target='_blank' href=" +
      readMeUrl +
      ">" +
      readMeText +
      "<span class='material-icons'>open_in_new</span></a>";
  }

  return (
    <div 
      className="listMobileCard"
      onClick={() => {
        if (selectMode !== ListSelectMode.Config) {
          onChange(object);
        }
      }}
      style={{ cursor: selectMode !== ListSelectMode.Config ? "pointer" : "default" }}
    >
      <div className="listMobileCardLeft">
        {isRecommended && (
          <div className="listMobileRecommended">
            <Badge text={`${t("recommended")}`} />
          </div>
        )}
        <div className="listMobileContent">
          <div>
            <ProductImage
              alt=""
              height={40}
              width={40}
              //src={imageLink}
              localSrc=""
            />
          </div>
          <div className="listMobileTexts">
            <div className="listMobilePreContent">{preContent}</div>
            <Tooltip title={title} arrow>
              <div
                className={
                  titleTruncate ? "listMobileTitle truncate" : "listMobileTitle"
                }
                style={{ maxWidth: titleMaxWidth }}
              >
                {title}
              </div>
            </Tooltip>
            <div
              className="listMobileContentValues"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </div>
        </div>
      </div>
      <div className="listMobileCardRight">
        <div
          className={
            selectMode !== ListSelectMode.Config
              ? "listMobileCardSelection"
              : ""
          }
        >
          {selectMode === ListSelectMode.Single && (
            <Radio
              checked={isSelected}
              readOnly
              sx={{
                "& .MuiSvgIcon-root": {
                  fontSize,
                },
                pointerEvents: "none",
              }}
            />
          )}
          {selectMode === ListSelectMode.Multi && (
            <Checkbox
              checked={isSelected}
              readOnly
              sx={{
                "& .MuiSvgIcon-root": {
                  fontSize,
                },
                pointerEvents: "none",
              }}
            />
          )}
          {selectMode === ListSelectMode.Config && (
            <RouterLink to={configLink}>
              <button className="listItemButtonConfig">
                <ModeEditOutlineOutlinedIcon />
              </button>
            </RouterLink>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListMobile;
